import React from 'react'
import { Modal } from '../../../Components/Modal'
import { ModalHeader } from '../../../Components/Modal/ModalHeader'
import { ModalTitle } from '../../../Components/Modal/ModalTitle'
import { ModalBody } from '../../../Components/Modal/ModalBody'
import { ModalFooter } from '../../../Components/Modal/ModalFooter'
import { SelectDashboard } from '../../../Components/Form/SelectDashboard'
import SubmitButton from '../../../Components/Form/SubmitButton'
import Typography from '@material-ui/core/Typography'

const UnbookModalView = ({
  show,
  handleCancel,
  handleConfirm,
  onReasonChange,
  options,
  value,
  title,
  disabled,
  text,
}) => (
  <Modal show={show}>
    <ModalHeader>
      <ModalTitle>{title}</ModalTitle>
    </ModalHeader>
    <ModalBody>
      {text ? (
        <Typography style={{ marginBottom: 20 }} align="center">
          {text}
        </Typography>
      ) : null}
      <SelectDashboard
        label={'Reason:'}
        input={{ name: 'unbookMission', value }}
        options={options}
        onChange={onReasonChange}
        cypress_id="unbook-mission-reason-dropdown"
      />
    </ModalBody>
    <ModalFooter>
      <SubmitButton
        variant="outlined"
        value="Cancel"
        onClick={handleCancel}
        cypress_id="unbook-mission-modal-cancel-button"
      />
      <SubmitButton
        value="Confirm"
        onClick={handleConfirm}
        disabled={disabled}
        cypress_id="unbook-mission-modal-confirm-button"
      />
    </ModalFooter>
  </Modal>
)

export default UnbookModalView
